import { type ReactNode } from 'react';
import { getPlusLinks, REPUB_CONFIG } from '@cx-web/repub-config';
import { getRepubMetaFromRepub } from '@cx-web/utils';
import { Button } from '@fpsm/cxy-components/Button';
import classNames from 'classnames';

import { type Repub } from '@cx-modules/types';

import styles from './styles/HeaderItems.module.css';

type LinkItem = {
  className: string;
  href: string;
  link: ReactNode;
};

export const HeaderItems = ({
  baseUrl,
  currentPathWithRepub,
  isTipstersEnabled,
  repub,
  resourcesUrl,
}: {
  baseUrl: string;
  currentPathWithRepub: string;
  isTipstersEnabled: boolean;
  repub: Repub;
  resourcesUrl: string;
}) => {
  const urlPrefix = `${REPUB_CONFIG[repub]?.plus?.plusHomePagePath ?? ''}/`;

  const getLinks = () => getPlusLinks({ repub, isTipstersEnabled, urlPrefix });
  const { repubIs } = getRepubMetaFromRepub(repub);

  const logoConfig = REPUB_CONFIG[repub]?.plus?.logo;

  const logoURL = () => {
    if (REPUB_CONFIG[repub]?.plus?.logoUrl) {
      return REPUB_CONFIG[repub]?.plus?.logoUrl;
    }
    return repubIs.GZ ? baseUrl + 'plus' : baseUrl;
  };

  const logoItem = logoConfig
    ? {
        href: logoURL(),
        className: styles.logo,
        link: (
          <picture className={styles.pictureWrapper}>
            {logoConfig.mobileSrc && <source media="(max-width: 1024px)" srcSet={logoConfig.mobileSrc(resourcesUrl)} />}
            <img
              alt={logoConfig.alt}
              className={styles.logoImage}
              src={logoConfig.src(resourcesUrl)}
              style={logoConfig.style}
            />
          </picture>
        ),
      }
    : null;

  const links = [...(logoItem ? [logoItem] : []), ...getLinks()] as LinkItem[];

  return (
    <ul className={styles.links}>
      {Object.values(links).map((item, index) => (
        <li
          className={classNames(styles.linkItem, currentPathWithRepub === item.href ? styles.isSelected : null, {
            [item.className]: item.className,
          })}
          key={`navigation-item-${index}`}
        >
          <Button asChild size="large">
            <a href={item.href}>{item.link}</a>
          </Button>
        </li>
      ))}
    </ul>
  );
};
